const RP_STATUS = {
    withRp: null,
    withoutRp: false,
    rpPending: true
} as const;

type ObjectValues<T> = T[keyof T];
type RPStatus = ObjectValues<typeof RP_STATUS>;

export {RP_STATUS, RPStatus};
